import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Grip } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

/** Friendly 403 for direct URL access or API 403 responses (server enforcement is authoritative). */
export default function AccessDeniedPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <div className="max-w-xl" data-testid="access-denied-page">
      <Card className="border-amber-200">
        <CardContent className="py-8 px-6">
          <div className="h-12 w-12 rounded-xl bg-amber-50 border border-amber-200 flex items-center justify-center mb-4">
            <ShieldAlert size={22} className="text-amber-700" />
          </div>
          <h1 className="font-heading text-xl font-bold">You don&apos;t have access to this area.</h1>
          <p className="text-sm text-muted-foreground mt-1">
            {state?.reason ? state.reason : 'This page or action requires a permission your role does not include.'}
          </p>
          <p className="text-xs text-muted-foreground mt-2" data-testid="access-denied-help">
            If you believe this is a mistake, contact a Super Admin. Access is derived server-side from your role, department and module assignment.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            <Button variant="outline" onClick={() => navigate(-1)} data-testid="access-denied-back-button"><ArrowLeft size={14} className="mr-1" /> Go back</Button>
            <Button asChild data-testid="access-denied-all-apps-button"><Link to="/"><Grip size={14} className="mr-1" /> All Apps</Link></Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
